import { Component, OnInit } from '@angular/core';

//services
import { TimeoutService } from '../../core/services/timeout.service';

@Component({
  selector: 'app-office-layout',
  templateUrl: './office-layout.component.html',
  styleUrls: ['./office-layout.component.css'],
})
export class OfficeLayoutComponent implements OnInit {
  noNav: boolean;

  constructor(private timeoutService: TimeoutService) {}

  ngOnInit(): void {
    if (window.location.pathname == '/reportgateway/index') this.noNav = true;
    this.timeoutService.initializeTimeoutConfig();
  }
}
